import { render, staticRenderFns } from "./OutsourcingConfiguration.vue?vue&type=template&id=454a6901&scoped=true&"
import script from "./OutsourcingConfiguration.vue?vue&type=script&lang=js&"
export * from "./OutsourcingConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingConfiguration.vue?vue&type=style&index=0&id=454a6901&scoped=true&lang=css&"
import style1 from "./OutsourcingConfiguration.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a6901",
  null
  
)

export default component.exports